import React, { useState, useContext } from 'react'
import { M_MessageBoard, M_Table, M_Button, LoadingContext, M_DrawerTableTextField, BufferService } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

export default function TrinomialBoard({ roles }) {

    const [line, setLine] = useState(null)
    const [modalAtribute, setModalAtribute] = useState(false)
    const [dataTrinomial, setDataTrinomial] = useState({})
    const [refresh, setRefresh] = useState(false)
    const bufferServiceTrinomial = new BufferService('TrinomialAssign')
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()

    const atributeTrinomial = () => {
        if (line && line.length > 0) {
            const selected = line[0]

            setDataTrinomial({
                Transport: selected.TransportLicensePlate || null,
                TransportId: selected.TransportId || null,
                Driver: selected.DriverName || null,
                DriverId: selected.DriverId || null,
                Trailer: selected.TrailerLicensePlate || null,
                TrailerId: selected.TrailerId || null,
            })

            setModalAtribute(true)
        } else {
            ctx.toastMessages('warning', t("SelectedLine"), '')
        }
    }

    const buildAvailabilityFilter = (resourceIdField, currentResourceId) => {
        const availableFilter = "Status eq 'Available'"

        if (!currentResourceId) return availableFilter

        return `(${availableFilter} or ${resourceIdField} eq ${currentResourceId})`
    }

    const submitTrinomial = () => {
        if (dataTrinomial.TransportId === null) {
            ctx.toastMessages('warning', t("TransportRequired"), '')
            return
        }

        if (dataTrinomial.DriverId === null && dataTrinomial.TrailerId === null) {
            ctx.toastMessages('warning', t("DriverOrTrailerRequired"), '')
            return
        }

        const updatedData = {
            ...dataTrinomial,
            Id: line[0].Id
        }

        setDataTrinomial(updatedData)

        const tempId = line[0].Id || "00000000-0000-0000-0000-000000000000"
        bufferServiceTrinomial.update(tempId, updatedData).then(response => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.response.data.Errors.toString(), '')
                return
            }
            ctx.toastMessages('success', '', t('SuccessUpdated'))
            setModalAtribute(false)
            setDataTrinomial({})
            setLine(null)
            setRefresh(true)
        })
    }

    const optionsTrinomial = [
        { Name: 'Transport', NormalizedName: t('Tractor'), type: 'string', IsDisabled: false, IsRequired: false, IsHiddenList: false, ForeignTableToPassId: 'TransportId', ForeignTableName: 'AvailableTransportBoardView', ForeignKeyName: 'LicensePlate', filter: buildAvailabilityFilter('TransportId', line?.[0]?.TransportId) },
        { Name: 'Driver', NormalizedName: t('Driver'), type: 'string', IsDisabled: false, IsRequired: false, IsHiddenList: false, ForeignTableToPassId: 'DriverId', ForeignTableName: 'AvailableDriverBoardView', ForeignKeyName: 'Name', filter: buildAvailabilityFilter('DriverId', line?.[0]?.DriverId) },
        { Name: 'Trailer', NormalizedName: t('Trailer'), type: 'string', IsDisabled: false, IsRequired: false, IsHiddenList: false, ForeignTableToPassId: 'TrailerId', ForeignTableName: 'AvailableTrailerBoardView', ForeignKeyName: 'LicensePlate', filter: buildAvailabilityFilter('TrailerId', line?.[0]?.TrailerId) },
    ]

    const deleteTrinomial = () => {
        const tempId = line[0].Id || "00000000-0000-0000-0000-000000000000"
        bufferServiceTrinomial.delete(tempId).then(response => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.response.data.Errors.toString(), '')
                return
            }
            ctx.toastMessages('success', '', t('SuccessDeleted'))
            setModalAtribute(false)
            setDataTrinomial({})
            setLine(null)
            setRefresh(true)
        })
    }

    return (
        <div>
            <M_Table
                entityName={'AvailableTrinomialBoardView'}
                rolePermissions={roles}
                filtersOnTable
                selectSingle
                onPassLine={(line) => {
                    if (!line || (Array.isArray(line) && line.length === 0)) {
                        setLine(null)
                    } else {
                        setLine(line)
                    }
                }}
                extraButtons={[
                    { label: t('EditTrinomial'), element: 'default', source: '/icons/svgsDaNet/truck-delivery.svg', style: {}, command: () => { atributeTrinomial() } },
                ]}
                refresh={refresh}
                setRefresh={setRefresh}
            />


            <M_MessageBoard
                success
                open={modalAtribute}
                title={`${t('EditTrinomialToVehicle')}: ${line ? line[0].TransportLicensePlate : ''}`}
                onClose={() => setModalAtribute(false)}
                body={<div>
                    {optionsTrinomial.map((elem, key) => (
                        <M_DrawerTableTextField
                            width={'100%'}
                            key={key}
                            tableLabel={elem.NormalizedName}
                            label={elem.NormalizedName}
                            required={elem.IsRequired}
                            entity={elem.ForeignTableName}
                            value={dataTrinomial[elem.ForeignTableToPassId] ?
                                {
                                    [elem.ForeignTableToPassId]: dataTrinomial[elem.ForeignTableToPassId],
                                    [elem.ForeignKeyName]: dataTrinomial[elem.Name]
                                } : null}
                            filterField={elem.ForeignKeyName}
                            labelFields={[elem.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    setDataTrinomial(prev => ({
                                        ...prev,
                                        [elem.Name]: obj[elem.ForeignKeyName],
                                        [elem.ForeignTableToPassId]: obj[elem.ForeignTableToPassId]
                                    }))
                                } else {
                                    setDataTrinomial(prev => ({
                                        ...prev,
                                        [elem.Name]: null,
                                        [elem.ForeignTableToPassId]: null
                                    }))
                                }
                            }}
                            valueField={elem.ForeignTableToPassId}
                            FILTER={elem.filter}
                        />
                    ))}
                </div>
                }
                footer={<div className='divFooterAlertsOrderService'>
                    {line?.[0]?.Id !== null && (
                        <M_Button
                            backgroundColor={'var(--color-red)'}
                            label={t("delete")}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteTrinomial()}
                        />
                    )}
                    <M_Button
                        backgroundColor={'var(--color-red)'}
                        label={t("Close")}
                        labelColor={'var(--color-white)'}
                        onClick={() => setModalAtribute(false)}
                    />
                    <M_Button
                        backgroundColor={'var(--color-green)'}
                        label={t("Save")}
                        labelColor={'var(--color-white)'}
                        onClick={() => {
                            submitTrinomial()
                        }}
                    />
                </div>}
            />
        </div>
    )
}